// Copyright 2025, University of Maryland, All Rights Reserved
import type { SchemaSection } from '@/api/types/schema'

// Define the core interfaces for schema type system
export interface SchemaTypeDefinition {
  id: string
  name: string 
  description: string
  field_types: SchemaFieldType[]
  icon?: string
  default_sections?: SchemaSection[]
}

export type SchemaFieldType = 'string' | 'integer' | 'simple_array' | 'object_array' | 'enum_field'

export const SCHEMA_TYPE_REGISTRY: Record<string, SchemaTypeDefinition> = {
  monitor: {
    id: 'monitor',
    name: 'Monitor Analysis', 
    description: 'Impact scoring with numerical assessments and rationale',
    field_types: ['integer', 'enum_field', 'string'],
    icon: 'BarChart'
  },
  legislative_review: {
    id: 'legislative_review',
    name: 'Legislative Review',
    description: 'Comprehensive analysis with executive summary, stakeholder analysis, and risk assessment',
    field_types: ['string', 'simple_array', 'object_array', 'integer', 'enum_field'],
    icon: 'FileText'
  }
}

// Utility functions
export function getSchemaTypeDefinition(schema_type: string): SchemaTypeDefinition | undefined {
  return SCHEMA_TYPE_REGISTRY[schema_type]
}

export function getAvailableSchemaTypes(): SchemaTypeDefinition[] {
  return Object.values(SCHEMA_TYPE_REGISTRY)
}

export function isValidSchemaType(schema_type: string): boolean {
  return schema_type in SCHEMA_TYPE_REGISTRY
}
